import { gateway } from './env'
import * as util from '../utils/util'
import axios from 'axios'
import { Message } from 'element-ui';
import router from "../router/index"

import { catchError } from '../utils/util';


//网络请求配置.
export const qunInstance = axios.create({
  baseURL: gateway,          //gateway
  timeout: 100000
})

async function parseBlobMessage(blobData) {
  if (!blobData) return ''
  if (typeof blobData.text !== 'function') return ''
  const text = await blobData.text()
  if (!text) return ''
  try {
    const json = JSON.parse(text)
    return json.message || json.msg || text
  } catch (e) {
    return text
  }
}

// 请求拦截器
qunInstance.interceptors.request.use(
  config => {
    if (config.customBaseURL != undefined) config.baseURL = config.customBaseURL;
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
  }
)
// 响应拦截器
qunInstance.interceptors.response.use(
  res => {
    if (res.data.code == 1500) {
      Message.error(res.data.message)
      router.push("/login")
      return
    }
    return Promise.resolve(res)
  },
  error => {
    const { response } = error
    catchError(response)
  }
)


export async function initUrl(url = '', data = {}, type = 'POST', specialConfig = {}) {
  type = type.toUpperCase()
  if (type === 'GET') {
    try {
      let res = await qunInstance({
        method: 'GET',
        url,
        params: data,
        responseType: specialConfig.responseType,
        customBaseURL: specialConfig.customBaseURL,
      })
      return new Promise((resolve) => {
        if (res.status == 200) {
          if (res.data.code == 1500) {
            res.status = res.data.code
            util.catchError(res)
          } else {
            resolve(res)
          }
        } else {
          res.status = res.data.code
          util.catchError(res)
        }
      })
    } catch (err) {

    }
  } else {
    try {
      let res = await qunInstance({
        method: 'POST',
        url,
        params: specialConfig.parameterType == 'QSP' ? data : undefined,
        data: specialConfig.parameterType == 'QSP' ? undefined : data
      })
      return new Promise((resolve) => {
        if (res.status == 200) {
          if (res.code == 1500) {
            res.status = res.code
            util.catchError(res)
          } else {
            resolve(res)
          }
        } else {
          res.status = res.data.code
          util.catchError(res)
        }
      })
    } catch (err) {
      util.catchError(err)
    }
  }
}

export async function downloadUrl(url = '', data = {}, type = 'POST', specialConfig = {}) {
  const token = sessionStorage.getItem('token')
  const requestType = type.toUpperCase()
  const headers = {
    'Content-Type': 'application/json'
  }
  if (token) {
    headers.Authorization = 'Bearer ' + token
  }
  try {
    const res = await axios({
      method: requestType,
      baseURL: specialConfig.customBaseURL || gateway,
      url,
      headers,
      params: requestType === 'GET' ? data : undefined,
      data: requestType === 'GET' ? undefined : data,
      responseType: 'blob',
      timeout: 100000
    })
    const contentType = (res.headers && res.headers['content-type']) || ''
    if (contentType.indexOf('application/json') !== -1) {
      const message = await parseBlobMessage(res.data)
      throw new Error(message || '文件导出失败')
    }
    return res
  } catch (err) {
    if (err && err.response) {
      const message = await parseBlobMessage(err.response.data)
      throw new Error(message || '文件导出失败')
    }
    throw (err instanceof Error ? err : new Error('文件导出失败'))
  }
}



// WEBPACK FOOTER //
// ./src/config/axios_config.js